<template>
  <div class="container-fluid mt-4 SlimTDs">
    <b-row>
      <b-col>
        <span :class="`size-${ButtonSize}`">Mutfaklar</span>
      </b-col>

      <b-col class="text-right mb-3 top-buttons">
        <b-btn class="m-1" type="button" variant="danger" to="/Settings" :size="ButtonSize">
          <i class="material-icons mifix">arrow_back</i>
          <span class="ml-1" v-if="ScreenWidth >= 370">Ayarlar</span>
        </b-btn>

        <b-btn to="/Settings/Kitchens/Add" class="btn-info m-1" :size="ButtonSize">
          <i class="material-icons mifix">add</i>
          <span class="ml-1">
            <span>Mutfak</span>
            <span class="ml-1" v-if="ScreenWidth >= 330">Ekle</span>
          </span>
        </b-btn>
      </b-col>
    </b-row>

    <b-table
      striped
      hover
      :sort-by.sync="sortBy"
      :sort-desc.sync="sortDesc"
      :items="Kitchens"
      :fields="fields"
      responsive
    >
      <template v-slot:cell(Name)="data">
        <div class="ws-nowrap">{{ data.item.Name }}</div>
      </template>

      <template v-slot:cell(Actions)="data">
        <b-btn size="sm" :to="`/Settings/Kitchens/${data.item.ID}`" class="mr-2">Düzenle</b-btn>
      </template>
    </b-table>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  data() {
    return {
      sortBy: "Name",
      sortDesc: false,
      fields: [
        { key: "Name", label: "Mutfak Adı", sortable: true },
        { key: "ProductsCount", label: "Ürün Sayısı", sortable: true },
        { key: "Status", label: "Durumu", sortable: true },
        { key: "Actions", label: "İşlem", sortable: false }
      ]
    };
  },
  computed: {
    ...mapState(["StoreData", "ScreenWidth", "ButtonSize"]),
    Kitchens() {
      let _Kitchens = [];

      if (this.StoreData.Kitchens)
        for (let i in this.StoreData.Kitchens) {
          const _Kitchen = this.StoreData.Kitchens[i];

          _Kitchens.push({
            ID: _Kitchen.ID,
            Name: _Kitchen.Name,
            ProductsCount: _Kitchen.Products
              ? Object.keys(_Kitchen.Products).length
              : 0,
            Status: _Kitchen.Status ? "Aktif" : "Pasif"
          });
        }

      return _Kitchens;
    }
  },
  mounted() {
    this.$store.subscribe(async () => {
      await this.$nextTick();
      await this.$forceUpdate();
    });
  }
};
</script>
